import { render, staticRenderFns } from "./TasksGroupSettingsMenu.vue?vue&type=template&id=6b29a644&scoped=true&"
import script from "./TasksGroupSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./TasksGroupSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TasksGroupSettingsMenu.vue?vue&type=style&index=0&id=6b29a644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29a644",
  null
  
)

export default component.exports
import {QBtnDropdown,QList,QItem,QItemSection,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign({QBtnDropdown,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
